export default __webpack_public_path__ + "static/media/check_out.c5a5f565.svg";